module.exports = __webpack_public_path__ + "static/media/sq1.3191c542.jpg";